import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from 'src/app/shared/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private readonly authCheckMaskId = 'auth-guard-loading-mask';
  constructor(private msal: MsalService, private router: Router,
    private auth: AuthService
  ) { }
  private showAuthCheckingMask(): void {
    if (typeof document === 'undefined') {
      return;
    }

    if (document.getElementById(this.authCheckMaskId)) {
      return;
    }

    const mask = document.createElement('div');
    mask.id = this.authCheckMaskId;
    Object.assign(mask.style, {
      position: 'fixed',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      zIndex: '99999',
      background: 'rgba(255, 255, 255, 0.45)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'all'
    });

    const spin = document.createElement('div');
    spin.className = 'ant-spin ant-spin-spinning ant-spin-lg ant-spin-show-text';

    const dot = document.createElement('span');
    dot.className = 'ant-spin-dot ant-spin-dot-spin';
    for (let i = 0; i < 4; i++) {
      const item = document.createElement('i');
      item.className = 'ant-spin-dot-item';
      dot.appendChild(item);
    }

    const text = document.createElement('div');
    text.className = 'ant-spin-text';

    spin.appendChild(dot);
    spin.appendChild(text);
    mask.appendChild(spin);

    document.body.appendChild(mask);
  }

  private hideAuthCheckingMask(): void {
    if (typeof document === 'undefined') {
      return;
    }

    const mask = document.getElementById(this.authCheckMaskId);
    if (mask) {
      mask.remove();
    }
  }
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    this.showAuthCheckingMask(); //显示加载遮罩
    try {
      const isLogin = await this.auth.isLoggedIn();
      if (isLogin) {
        var urls = [
          '/pages/wmsm-pages/Source/sourcingrequest',
          '/pages/wmsm-pages/Source/buyerapproval',
          '/pages/wmsm-pages/Source/Report/SourcingRequest',
          '/pages/wmsm-pages/Source/Report/EndUserSRReport',
        ];
        if (urls.includes(state.url)) {
          localStorage.setItem('originalUrl', state.url);
        }

        return true;
      } else {
        const currentUrl = window.location.href;
        if (!currentUrl.toUpperCase().includes('login'.toUpperCase())) {
          this.auth.setRedirectUrl(currentUrl);
        }
        //要完全登出/清除登錄相關狀態,重新登錄
        this.auth.logoutAndClearAll();
        return false;
      }
    } finally {
      this.hideAuthCheckingMask(); //隐藏加载遮罩
    }
  }
}
